import ListComponent from './component'
import { commonRenderProps } from '../common/props'
import {
  openChargebeeCheckout,
  includeChargebeeScript,
} from '../common/useChargebee'
import LoadBanner from './banner/loadBanner'

const CARRIER_BANNER_STORAGE_KEY = 'mbo_carrier_banner_loaded_'

export default (context: object, container: string) => {
  let closeAccordion: (() => void) | null = null
  let closeDepartureSelect: (() => void) | null = null
  includeChargebeeScript()

  const closeRecommendationsAccordion = () => {
    closeAccordion?.()
  }

  const handleHostPointerDown = () => {
    closeDepartureSelect?.()
  }

  const props = {
    ...commonRenderProps({ context }),

    controllerName:
      context['prestaShop_controller_class_name'] ||
      context['prestaShopControllerClassName'] ||
      '',

    initialBannerState: (() => {
      const shopUid = context['accounts_shop_id'] || ''
      return localStorage.getItem(CARRIER_BANNER_STORAGE_KEY + shopUid)
    })(),

    registerCloseAccordion: (fn: () => void) => (closeAccordion = fn),
    registerCloseDepartureSelect: (fn: () => void) =>
      (closeDepartureSelect = fn),

    handleOpenChargebeeCheckout: (opts) => openChargebeeCheckout(opts),
  }

  window.addEventListener('pointerdown', handleHostPointerDown, true)
  ListComponent(props).render(container)
  LoadBanner(context, closeRecommendationsAccordion)
}
